import * as yup from 'yup';

const validationSchema = yup.object({
  apps: yup.array().min(1).required(1),
});

export { validationSchema };
